import { create } from "../../../common/utils/zustand_state_manager";
import { useDiarioObraServices } from "./use_services";
import { IDiarioObraRepository } from "../../../features/diarioObra/domain/repositories/diario_obra_repository";
import { DiarioObraRepository } from "../../../features/diarioObra/data/repositories/diario_obra_repository";

//useDiarioObrasRepositories

type State = {
  diarioObraRepository: IDiarioObraRepository,
};

export const useDiarioObrasRepositories = create<State>((set, get) => {
  const { diarioObraService } = useDiarioObraServices.getState();
  return ({
    diarioObraRepository: new DiarioObraRepository(diarioObraService),
  });
});